/*
  Pixkom-Gestaltungssystem: die Klick-Welle.
  Jedes Element mit [data-pk-welle] antwortet auf einen Klick mit einem Ring aus dem Logo-„O“.
  Ein Ereignis-Lauscher für die ganze Seite, damit auch nachgeladene Inhalte mitmachen.
  Bei „Bewegung reduzieren“ passiert nichts.
*/
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener(
    'pointerdown',
    (event) => {
      const ziel = event.target instanceof Element ? event.target.closest('[data-pk-welle]') : null;
      if (!ziel) return;
      const rect = ziel.getBoundingClientRect();
      const welle = document.createElement('span');
      welle.className = 'pk-welle';
      welle.setAttribute('aria-hidden', 'true');
      welle.style.left = `${event.clientX - rect.left}px`;
      welle.style.top = `${event.clientY - rect.top}px`;
      ziel.appendChild(welle);
      welle.addEventListener('animationend', () => welle.remove());
    },
    { passive: true }
  );
})();

/*
  Bilder im Mega-Menü (snippets/pk-mega.liquid) laden erst, wenn jemand das Menü öffnen will:
  beim Zeigen auf einen Menüpunkt oder beim Fokus. Spart beim Seitenaufbau rund 30 Bildanfragen.
*/
(() => {
  const laden = (punkt) => {
    punkt.querySelectorAll('img[data-pk-src]').forEach((img) => {
      img.src = img.dataset.pkSrc;
      img.removeAttribute('data-pk-src');
    });
  };
  ['pointerover', 'focusin'].forEach((art) =>
    document.addEventListener(
      art,
      (event) => {
        const punkt = event.target instanceof Element ? event.target.closest('.menu-list__list-item') : null;
        if (punkt) laden(punkt);
      },
      { passive: true }
    )
  );
})();

